import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          当前最受关注的综艺话题与讨论热度
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item) => {
            const colorMap: Record<string, string> = {
              hot: 'bg-primary-100 text-primary-700 border-primary-200',
              warm: 'bg-accent-100 text-accent-700 border-accent-200',
              normal: 'bg-secondary-100 text-secondary-600 border-secondary-200',
            };
            return (
              <span
                key={item.id}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-colors duration-200 cursor-default ${colorMap[item.color]}`}
              >
                <span>{item.name}</span>
                <span className="text-xs opacity-70 font-mono">{item.heat}</span>
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}